import React from 'react'
import { Row, Col, Label, Input, FormGroup } from 'reactstrap';
import { SelectForm } from '../../Basicos';
const ParteSuperior = ({ optionsSelect, setDadosFiltrados, setValoresFiltro, valoresFiltro, isActive, getTemas, getEtapas, getProfessoresFiltro, handleFiltrar, handleLimpar }) => {

  const onChangeSelect = (nome, valor) => {
    switch (nome) {
      case 'curso_id':
        setValoresFiltro({ ...valoresFiltro, curso_id: valor })
        const filtraCurso = optionsSelect[0].filter(dado => (dado.curso_id == valor))
        setDadosFiltrados(filtraCurso)
        break;
      case 'periodo_letivo_id':
        setValoresFiltro({ ...valoresFiltro, periodo_letivo_id: valor, etapa_id: undefined })
        const filtraPeriodoLetivo = optionsSelect[1].filter(dado => (dado.periodo_letivo_id == valor))
        setDadosFiltrados(filtraPeriodoLetivo)
        getEtapas(valor)
        break;
      case 'etapa_id': {
        const etapaSelecionada = optionsSelect[8]?.find(e => (e.value || e.id) === valor);
        if (etapaSelecionada) {
          setValoresFiltro({
            ...valoresFiltro,
            etapa_id: valor,
            data_inicial: etapaSelecionada.data_inicio,
            data_final: etapaSelecionada.data_fim
          });
        } else {
          setValoresFiltro({ ...valoresFiltro, etapa_id: undefined });
        }
        break;
      }
      case 'semestre_id': {
        const novosFiltros = { ...valoresFiltro, semestre_id: valor };
        setValoresFiltro(novosFiltros)
        const filtraSemestre = optionsSelect[2].filter(dado => (
          dado.curso_id == valoresFiltro.curso_id
          && dado.semestre_id == valor))
        setDadosFiltrados(filtraSemestre)
        getTemas(valor)
        getProfessoresFiltro(novosFiltros)
        break;
      }
      case 'tema_id': {
        const novosFiltros = { ...valoresFiltro, tema_id: valor };
        setValoresFiltro(novosFiltros);
        getProfessoresFiltro(novosFiltros);
        break;
      }
      case 'tipo_atividade_id': {
        const novosFiltros = { ...valoresFiltro, tipo_atividade_id: valor };
        setValoresFiltro(novosFiltros);
        getProfessoresFiltro(novosFiltros);
        break;
      }
      default:
        setValoresFiltro({ ...valoresFiltro, [nome]: valor })
        break;
    }
  }

  const onChangeDate = (e) => {
    setValoresFiltro({ ...valoresFiltro, [e.target.name]: e.target.value, etapa_id: undefined })
  }

  const style = {
    col2: { xs: 6, md: 2, sm: 4, lg: 2, xl: 2 }
  }
  return (
    <Col xs="12">
      <Label xs={12} style={{ padding: 0, marginBottom: '25px', paddingLeft: '15px' }}>
        <b className="label-nome-pagina" style={{ fontSize: '28px', color: '#1A23DF', fontWeight: 'bold' }}>Dashboard</b>
      </Label>
      {isActive && (
        <Row style={{ padding: '0 15px' }}>
          <SelectForm label="Curso" name="curso_id" placeholder="Curso" options={optionsSelect[0] || []} onChange={onChangeSelect} value={(optionsSelect[0] && optionsSelect[0].find(o => (o.value || o.id) === valoresFiltro.curso_id)) || null} style={{ col: style.col2, labelClass: "label-conteudoInferior" }} />
          <SelectForm label="Período Letivo*" name="periodo_letivo_id" placeholder="Período Letivo*" options={optionsSelect[1] || []} value={(optionsSelect[1] && optionsSelect[1].find(o => (o.value || o.id) === valoresFiltro.periodo_letivo_id)) || null} onChange={onChangeSelect} style={{ col: style.col2, labelClass: "label-conteudoInferior" }} />
          <SelectForm label="Semestre" name="semestre_id" placeholder="Semestre" options={optionsSelect[2] || []} value={(optionsSelect[2] && optionsSelect[2].find(o => (o.value || o.id) === valoresFiltro.semestre_id)) || null} onChange={onChangeSelect} readOnly={!valoresFiltro.curso_id} style={{ col: style.col2, labelClass: "label-conteudoInferior" }} />
          <SelectForm label="Turma" name="turma_id" placeholder="Turma" options={optionsSelect[3] || []} value={(optionsSelect[3] && optionsSelect[3].find(o => (o.value || o.id) === valoresFiltro.turma_id)) || null} onChange={onChangeSelect} style={{ col: style.col2, labelClass: "label-conteudoInferior" }} />
          <SelectForm label="Tema" name="tema_id" placeholder="Tema" options={optionsSelect[6] || []} value={(optionsSelect[6] && optionsSelect[6].find(o => (o.value || o.id) === valoresFiltro.tema_id)) || null} onChange={onChangeSelect} style={{ col: style.col2, labelClass: "label-conteudoInferior" }} />
          <SelectForm label="Etapa" name="etapa_id" placeholder="Etapa" options={optionsSelect[8] || []} value={(optionsSelect[8] && optionsSelect[8].find(o => (o.value || o.id) === valoresFiltro.etapa_id)) || null} onChange={onChangeSelect} style={{ col: style.col2, labelClass: "label-conteudoInferior" }} />

          <div className="w-100 d-none d-md-block" style={{ marginTop: '5px', marginBottom: '10px' }}></div>

          <Col xs={6} md={2} sm={4} lg={2} xl={2} className="form-col">
            <FormGroup>
              <Label className="label-conteudoInferior label" style={{ marginBottom: '5px', fontSize: '13px', color: '#555' }}>Data Inicial*:</Label>
              <Input type="date" name="data_inicial" value={valoresFiltro.data_inicial || ''} onChange={onChangeDate} style={{ borderRadius: '0.7rem', border: '1px solid #ced4da', fontSize: '14px', height: '38px', color: '#495057', backgroundColor: '#fff', width: '100%', outline: 'none', padding: '.375rem .75rem' }} />
            </FormGroup>
          </Col>
          <Col xs={6} md={2} sm={4} lg={2} xl={2} className="form-col">
            <FormGroup>
              <Label className="label-conteudoInferior label" style={{ marginBottom: '5px', fontSize: '13px', color: '#555' }}>Data Final*:</Label>
              <Input type="date" name="data_final" value={valoresFiltro.data_final || ''} onChange={onChangeDate} style={{ borderRadius: '0.7rem', border: '1px solid #ced4da', fontSize: '14px', height: '38px', color: '#495057', backgroundColor: '#fff', width: '100%', outline: 'none', padding: '.375rem .75rem' }} />
            </FormGroup>
          </Col>
          <SelectForm label="Professor" name="professor_id" placeholder="Professor" options={optionsSelect[4] || []} value={(optionsSelect[4] && optionsSelect[4].find(o => (o.value || o.id) === valoresFiltro.professor_id)) || null} onChange={onChangeSelect} style={{ col: style.col2, labelClass: "label-conteudoInferior" }} />
          <SelectForm label="Tipo Atividade" name="tipo_atividade_id" placeholder="Tipo Atividade" options={optionsSelect[5] || []} value={(optionsSelect[5] && optionsSelect[5].find(o => (o.value || o.id) === valoresFiltro.tipo_atividade_id)) || null} onChange={onChangeSelect} style={{ col: style.col2, labelClass: "label-conteudoInferior" }} />
          <SelectForm label="Status" name="status_id" placeholder="Status" options={optionsSelect[7] || []} value={(optionsSelect[7] && optionsSelect[7].find(o => (o.value || o.id) === valoresFiltro.status_id)) || null} onChange={onChangeSelect} style={{ col: style.col2, labelClass: "label-conteudoInferior" }} />

          <Col xs={6} md={2} sm={4} lg={2} xl={2} className="form-col" style={{ display: 'flex', alignItems: 'flex-end', gap: '8px', paddingBottom: '0' }}>
            <FormGroup style={{ width: '100%', marginBottom: '1rem', display: 'flex', gap: '8px' }}>
              <button
                onClick={handleFiltrar}
                className="btn-filtrar-dashboard"
                style={{ backgroundColor: '#1A23DF', color: '#fff', border: 'none', borderRadius: '0.7rem', padding: '0 15px', fontSize: '13px', fontWeight: 'bold', cursor: 'pointer', height: '38px', flex: 1, display: 'flex', alignItems: 'center', justifyContent: 'center', transition: 'all 0.2s' }}
                onMouseOver={(e) => e.currentTarget.style.backgroundColor = '#010bdb'}
                onMouseOut={(e) => e.currentTarget.style.backgroundColor = '#1A23DF'}
              >
                Filtrar
              </button>
              <button
                onClick={handleLimpar}
                className="btn-limpar-dashboard"
                style={{ backgroundColor: '#fff', color: '#1A23DF', border: '1px solid #1A23DF', borderRadius: '0.7rem', padding: '0 15px', fontSize: '13px', fontWeight: 'bold', cursor: 'pointer', height: '38px', flex: 1, display: 'flex', alignItems: 'center', justifyContent: 'center', transition: 'all 0.2s' }}
                onMouseOver={(e) => { e.currentTarget.style.backgroundColor = '#f8f9fa'; }}
                onMouseOut={(e) => { e.currentTarget.style.backgroundColor = '#fff'; }}
              >
                Limpar
              </button>
            </FormGroup>
          </Col>
        </Row>
      )}
    </Col>
  )
}

export default ParteSuperior
